// extracted by mini-css-extract-plugin
module.exports = {"compare_table":"CompareTable_compare_table__1b9_D","add_vehicle_btn":"CompareTable_add_vehicle_btn__1Ol1O","remove_vehicle_btn":"CompareTable_remove_vehicle_btn__C8GAK"};